"use client";

import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface ClientPortalProps {
  children: ReactNode;
  selector: string;
}

export default function ClientPortal({
  children,
  selector,
}: ClientPortalProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const element = document.querySelector(selector);

  if (!element) {
    console.warn(
      `ClientPortal: El selector "${selector}" no se encontró en el DOM.`
    );
    return null;
  }

  return createPortal(children, element);
}
